import { useEffect, useState } from "react";
import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import { formatarData } from "../../../Funcoes/FormatarData";
import useApi from "../../../hooks/useApi";

const Titulo = styled.h2`
    margin: 0 0 6px 0;
    font-size: 18px;
    font-weight: 700;
    color: #263b4b;
`;

const Subtitulo = styled.p`
    margin: 0 0 16px 0;
    font-size: 13px;
    color: #666;
`;

const TabelaWrap = styled.div`
    width: 100%;
    max-height: 55vh;
    overflow: auto;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
`;

const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    thead {
        position: sticky;
        top: 0;
        background: #f0f0f0;
        z-index: 1;
    }

    th,
    td {
        padding: 10px 12px;
        text-align: left;
        border-bottom: 1px solid #e5e5e5;
    }

    th {
        font-weight: 700;
        color: #333;
    }

    tbody tr:nth-child(even) {
        background: #fafafa;
    }
`;

const StatusBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    color: ${({ $valido }) => ($valido ? "#1b5e20" : "#b71c1c")};
    background: ${({ $valido }) => ($valido ? "#c8e6c9" : "#ffcdd2")};
`;

const Empty = styled.p`
    margin: 20px 0;
    text-align: center;
    color: #777;
    font-size: 14px;
`;

const formatValidade = (item) => {
    if (!item) return "-";
    if (item.sem_vencimento) return "SEM VENCIMENTO";
    if (!item.validade) return "-";

    try {
        const raw = String(item.validade).slice(0, 10);
        return formatarData(raw) || "-";
    } catch {
        return "-";
    }
};

const ModalDetalhe = ({ colaborador, onClose }) => {
    const api = useApi();
    const [loading, setLoading] = useState(true);
    const [treinamentos, setTreinamentos] = useState([]);

    useEffect(() => {
        if (!colaborador) return undefined;

        let cancelled = false;

        const fetchDetalhe = async () => {
            setLoading(true);
            try {
                const { data } = await api.get(
                    "/Painel/API/Treinamentos/TreinamentosStatus/Detalhe/",
                    {
                        params: {
                            cpf: colaborador.cpf,
                            funcao: colaborador.funcao,
                            centro_custo: colaborador.centro_custo,
                        },
                    }
                );

                if (!cancelled) {
                    setTreinamentos(
                        Array.isArray(data?.treinamentos) ? data.treinamentos : []
                    );
                }
            } catch (error) {
                console.error(error);
                if (!cancelled) {
                    setTreinamentos([]);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        fetchDetalhe();

        return () => {
            cancelled = true;
        };
    }, [api, colaborador]);

    return (
        <Overlay state={true} changeState={onClose}>
            <Modal size="lg" header close={onClose}>
                <Titulo>{colaborador?.nome || "Colaborador"}</Titulo>
                <Subtitulo>
                    {colaborador?.funcao || "-"}
                    {colaborador?.centro_custo
                        ? ` · ${colaborador.centro_custo}`
                        : ""}
                    {colaborador?.ghe ? ` · GHE: ${colaborador.ghe}` : ""}
                </Subtitulo>

                {loading ? (
                    <SmallLoading />
                ) : treinamentos.length === 0 ? (
                    <Empty>Nenhum treinamento obrigatório cadastrado.</Empty>
                ) : (
                    <TabelaWrap>
                        <Tabela>
                            <thead>
                                <tr>
                                    <th>TREINAMENTO</th>
                                    <th>STATUS</th>
                                    <th>VALIDADE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {treinamentos.map((item) => (
                                    <tr key={item.treinamento_id}>
                                        <td>{item.treinamento}</td>
                                        <td>
                                            <StatusBadge $valido={!!item.valido}>
                                                {item.valido ? "VÁLIDO" : "NÃO VÁLIDO"}
                                            </StatusBadge>
                                        </td>
                                        <td>{formatValidade(item)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Tabela>
                    </TabelaWrap>
                )}
            </Modal>
        </Overlay>
    );
};

export default ModalDetalhe;
